if (!customElements.get('scroll-to')) {
  class ScrollTo extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      const anchor = this.querySelector('a');
      if(!anchor) return;

      const target = document.querySelector(`[data-scroll-id="${anchor.getAttribute('data-scroll')}"]`);
      if(!target) return;

      const topOffset = target.parentElement.offsetTop - this.getHeaderOffset();
      window.scrollTo({
        top: topOffset,
        behavior: 'smooth'
      })
    }

    getHeaderOffset() {
      const headerOffsetProp = document.documentElement.style.getPropertyValue('--header-height');
      return Number(headerOffsetProp.replace('px', '')) || 0;
    }
    
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('scroll-to', ScrollTo);
}
